<template>
  <q-dialog :visible="isVisible" :title="title" width="50%" :innerScroll="false" :showFooter="false" @cancel="onCancelImport" @close="onCancelImport">
    <div v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" style="padding: 20px 0">
      <el-form :model="requestParam" :rules="rules" ref="requestParam" label-width="100px" size="mini">
        <el-row>
          <el-col :span="24" align="left">
            <el-form-item label="产品名称:" prop="productCode">
              <!-- <el-select v-model="requestParam.productCode" filterable remote placeholder="请输入关键词" :remote-method="remoteMethod" :loading="loadingInput">
                <el-option v-for="item in productList" :key="item.productCode" :label="item.productName" :value="item.productCode"> </el-option>
              </el-select> -->
              <el-select
                  v-model="requestParam.productCode"
                  v-el-select-loadmore:rangeNumber="loadMore(rangeNumber)"
                  @visible-change="selectFilter(false)"
                  :filter-method="selectFilter"
                  filterable
                >
                  <el-option v-for="item in productList.slice(0, rangeNumber)" :label="item.productName" :key="item.productCode" :value="item.productCode"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="上传类型:" prop="uploadType">
              <el-select v-model="requestParam.uploadType">
                <el-option v-for="item in ['普通', '京东', '天猫', '其他']" :key="item" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" align="left">
            <el-form-item label="附件:">
              <el-upload
                class="upload-demo"
                accept=".jpg,.jpeg,.png,.gif,.zip"
                ref="upload"
                multiple
                :limit="999"
                action=""
                :disabled="disabled"
                :http-request="httpRequest"
                :on-remove="handleRemove"
                :headers="headers"
                :file-list="fileList"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
              >
                <el-button slot="trigger" size="small" type="primary" @click="importFile">选取文件夹</el-button>
                <el-button
                  style="margin-left: 10px"
                  v-loading.fullscreen.lock="fjLoading"
                  element-loading-text="数据导入中"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  size="small"
                  type="success"
                  @click="checkFormValid"
                  >上传
                </el-button>
                <el-button type="text" style="color: red" size="mini" @click="clearFileModel">一键清空</el-button>
                <div slot="tip" class="el-upload__tip">请上传文件夹，文件夹内需包含一张“模型图片和“模型”压缩包文件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center">
        <el-button @click="onCancelImport" size="medium">取 消</el-button>
      </div>
    </div>
  </q-dialog>
</template>

<script>
import moment from 'moment';
import { getToken } from '@/utils/auth';
import axios from '@/utils/axiosInstance';
import Vue from "vue";
Vue.directive('el-select-loadmore', {
  bind(el, binding) {
    let self = this;
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    SELECTWRAP_DOM.addEventListener('scroll', function () {
      /**
       * scrollHeight 获取元素内容高度(只读)
       * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
       * clientHeight 读取元素的可见高度(只读)
       * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
       * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
       */
      const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
      if (condition) binding.value();
    });
  },
});
export default {
  name: 'up',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    spuId: [String, Number],
    processType: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '批量上传';
    },
  },
  watch: {},
  data() {
    return {
      loading: false,
      loadingInput: false,
      requestParam: {},
      rules: {
        businessType: [{ required: true, message: '不能为空', trigger: 'change' }],
        uploadType: [{ required: true, message: '不能为空', trigger: 'change' }],
        productCode: [{ required: true, message: '不能为空', trigger: 'change' }],
      },
      headers: {
        Authorization: getToken(),
      },
      fileList: [],
      fileListAll: [],
      productList: [],
      productListSearch: [],
      fjLoading: false,
      errorType: false,
      disabled: false,
      rangeNumber: 10,
    };
  },
  mounted() {
    this.getProductList()
    this.$nextTick(() => {
      this.$refs.upload.$children[0].$refs.input.webkitdirectory = true;
    });
  },
  methods: {
    loadMore(n) {
      return () => (this.rangeNumber += 5)
    },
    selectFilter(value) {
      if(value){
        this.productList = this.productListSearch.filter(item => {
          if(item.productName.includes(value)){
              return item
          }
        })
      }else{
        setTimeout(()=>{
          this.productList = this.productListSearch
        },350)
      }
    },
    onCancel() {
      this.isVisible = false;
    },
    onCancelImport() {
      this.isVisible = false;
      this.fileList = [];
      this.fileListAll = [];
    },

    async remoteMethod(productName) {
      if (productName.length < 4) return;
      if (!productName) {
        this.requestParam.productCode = '';
        this.productList = [];
        return;
      }
      this.loadingInput = true;
      let data = {
        pageSize: 999999,
        pageNum: 1,
        filterData: {
          productName: productName,
        },
      };
      this.productList = await this.$q.product
        .baseList({ data: data })
        .then(({ data }) => {
          this.loadingInput = false;
          return Array.isArray(data.records) ? data.records : [];
        })
        .catch((err) => {
          this.loadingInput = false;
          console.log(err);
          return [];
        });
    },

    importFile(event) {
      if (this.fileList.length) {
        this.$message.error(`一次仅上传一个模型文件夹`);
        this.disabled = true;
        setTimeout(() => {
          this.disabled = false;
        }, 20);
        return;
      }
      this.errorType = false;
    },

    clearFileModel() {
      this.fileList = [];
      this.fileListAll = [];
    },

    handleRemove(file, fileList) {
      if (this.errorType) {
        this.fileList = [];
        return;
      }
      this.fileList = fileList;
      console.log(file, fileList);
    },
    httpRequest(file) {},
    handleSuccess(res, file) {
      if (res.code === 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.onCancel();
    },
    // 验证
    beforeUpload(file) {
      // console.log(file.webkitRelativePath);
      // console.log(this.fileList);
      let pattern = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
      if (pattern != 'db' && pattern != 'ds_store') {
        //排除隐藏.db系统文件
        this.fileListAll.push(file);
      }
      if (this.errorType) {
        this.fileList = [];
        return;
      }
      if (!this.errorType && pattern != 'db' && pattern != 'ds_store') {
        this.fileList.push(file);
      }
    },
    checkFormValid(file) {
      this.$refs['requestParam'].validate((valid) => {
        if (valid) {
          this.submitUpload(file);
        } else {
          this.$message.error('参数校验失败！');
        }
      });
    },
    submitUpload(file) {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.error('请先上传模型文件');
        return;
      }
      const form = new FormData();
      const { productCode, uploadType } = this.requestParam;
      const productName = this.productList.find((v) => v.productCode == productCode).productName;
      form.append('productCode', productCode);
      form.append('productName', productName);
      form.append('uploadType', uploadType);
      const _this = this;
      var zipErro = [];
      var imgErro = [];
      this.fileList.forEach((v) => {
        let pattern = v.name.substring(v.name.lastIndexOf('.') + 1).toLowerCase();
        form.append('files', v);
        if(['zip','rar','7z','tar','gz','tgz','bz2','xz','tbz2','tbz','txz','tb2','tbz2','tx2'].includes(pattern) ) {
          zipErro.push(1)
        }
        if(['png','jpg','jpeg','gif','bmp','svg'].includes(pattern)) {
          imgErro.push(1)
        }
      });
      if (!zipErro.length || !imgErro.length) {
        this.$message.error('请确认文件夹上传规范是否正确');
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '图片上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)',
      });
      this.$q.newProduct
        .productModelBatchUpload({ data: form })
        .then((res) => {
          if (res.code == 200 && res.data) {
            var timer = setInterval(function () {
              _this.$q.common
                .reportTaskInfo({ fragment: [res.data] })
                .then((res) => {
                  if (res.data.taskStatus == '执行完成') {
                    clearInterval(timer);
                    loading.close();
                    if (res.data.taskResult == '成功') {
                      _this.$message.success('上传成功');
                      _this.isVisible = false;
                      _this.$emit('complete');
                    } else {
                      _this.onCancelImport();
                      _this.$message.error(res.data.failReason);
                    }
                  }
                })
                .catch((err) => {
                  loading.close();
                  this.$message.error(err.message);
                });
            }, 5000);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((_) => {
          loading.close();
        });
    },
    getProductList() {
      this.$q.shortVideoOverview.videoProductList().then((res) => {
        if (res.code == 200) {
          this.productList = res.data;
          this.productListSearch = JSON.parse(JSON.stringify(res.data));
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px
}


.right50 {
  margin-right: 50px;
}

.footer {
  margin: 15px 0 5px 0;
  text-align: center
}

 >>> .el-upload-list {
   max-height: 50vh
   overflow-y: auto
 }

>>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 240px !important
</style>
